import { format } from "date-fns";

export const handleDateTimeDefault = (date, formatType = "dd-MM-yyyy hh:mm:ss a") => {
    try {
        return format(new Date(date), formatType)
    } catch (e) {
        return "Invalid Date";
    }
}

export const convertCSVToJson = (csvData) => {
    const lines = csvData.split("\n");
    const headers = (lines[0] || "").split(",");
    const result = [];

    for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentLine = lines[i].split(",");

        if (!currentLine.some((value) => (value || "").trim() !== "")) {
            continue;
        }

        for (let j = 0; j < headers.length; j++) {
            obj[headers[j].trim().toLowerCase()] = (currentLine[j] || "").trim();
        }

        result.push(obj);
    }

    return result;
};

export function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export const calculateAge = (birthday) => {
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function hasChildren(item) {
    const { items: children } = item;

    if (children === undefined) {
        return false;
    }

    if (children.constructor !== Array) {
        return false;
    }

    if (children.length === 0) {
        return false;
    }

    return true;
}
